import SettingsIcon from '@mui/icons-material/Settings';
import { DownloadIcon } from 'common/components/Elements/Icon/Icon';
import type * as I from 'core/api/coreApiClient';
import React from 'react';

type StyleHint = I.Command['styleHint'];

function StyleHintIcon(styleHint: StyleHint) {
  if (styleHint === 'export') {
    return (<DownloadIcon />);
  }

  if (styleHint === 'et_trigger') {
    return (<SettingsIcon fontSize="small" />);
  }

  return null;
}

export default StyleHintIcon;
